<template>
  <div>
    <v-layout
      row
      wrap
    >
      <v-flex>

        <h2 class="display-1 mt-4 ml-4">
          <span class="hidden-xs-only">Veranstaltungskalender für</span>
          <span class="hidden-sm-and-up">Kalender für</span>
          {{ deutscherMonat }}
          <v-btn
            icon
            @click="getKalender()"
            :loading="isLoadingKal"
          >
            <v-icon>refresh</v-icon>
          </v-btn>

        </h2>
      </v-flex>
      <v-flex class="text-xs-right mt-4 mr-3">
        <termin-hinzufugen
          :kalender="this.kalender"
          @kalenderrefresh="getKalender()"
          v-if="darfadmin"
        ></termin-hinzufugen>
      </v-flex>
    </v-layout>

    <v-container fluid>
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          order-xs2
          order-md1
        >
          <v-layout
            row
            wrap
            justify-space-between
          >
            <v-flex
              sm3
              xs12
              order-xs2
              order-sm1
              class="text-xs-left pr-3"
              :class="{ 'mb-1 mt-0': this.$vuetify.breakpoint.name === 'xs'}"
            >
              <v-btn
                @click="$refs.calendar.prev()"
                flat
                block
              >
                <v-icon
                  dark
                  left
                >
                  keyboard_arrow_left
                </v-icon>
                vorheriger Monat
              </v-btn>
            </v-flex>

            <v-flex
              xs12
              sm6
              class="pr-3"
              order-xs1
              order-sm2
            >
              <v-select
                v-model="selectedKalender"
                :items="this.kalender"
                item-text="name"
                item-value="id"
                label="Kalender wählen"
                multiple
                no-data-text="Aktuell keine Kalender für Sie verfügbar."
                outline
                chips
                deletable-chips
                return-object
                single-line
              >
                <template v-slot:prepend-item>
                  <v-list-tile
                    ripple
                    @click="toggle"
                  >
                    <v-list-tile-action>
                      <v-icon :color="selectedKalender.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Alle anzeigen</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:append-item>
                  <v-divider class="mb-2"></v-divider>
                  <v-list-tile disabled>
                    <v-list-tile-avatar color="grey lighten-3">
                      <v-icon>event</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content v-if="likesAllFruit">
                      <v-list-tile-title>Aktuell werden alle verfügbaren Kalender angezeigt</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-content v-else-if="likesSomeFruit">
                      <v-list-tile-title>Anzahl Kalender</v-list-tile-title>
                      <v-list-tile-sub-title>{{ selectedKalender.length }}</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-content v-else>
                      <v-list-tile-title>
                        Möchten Sie Termine sehen?
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        Wählen Sie aus, was Sie interessiert!
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-select>
            </v-flex>
            <v-flex
              order-xs4
              class="hidden-sm-and-up title"
            >
              {{ deutscherMonat }}
            </v-flex>

            <v-flex
              sm3
              offset-sm0
              xs12
              offset-xs0
              order-xs3
              class="text-xs-right"
              :class="{ 'mb-1 mt-2': this.$vuetify.breakpoint.name === 'xs'}"
            >
              <v-btn
                @click="$refs.calendar.next()"
                flat
                block
              >
                nächster Monat
                <v-icon
                  right
                  dark
                >
                  keyboard_arrow_right
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          xs12
          md3
          order-xs1
          order-md2
          mb-3
        >
        <span v-if="this.kalender">
          <termin-liste :events="sortedlimitMap" expand v-if="this.kalender.length > 0"></termin-liste>
        </span>
          <v-card
            v-if="darfadmin"
            class="mr-3 mt-4 mb-3"
          >
            <v-card-text>
              <span class="subheading">Berechtigung</span><br><br> Sie können Termine hinzufügen. (oben rechts) <br><br> Wenn Sie einen Termin ändern wollen, löschen Sie Ihn bitte über das <v-icon>delete_forever</v-icon> Symbol in der Detailansicht und tragen Sie den Termin neu ein.</v-card-text>

          </v-card>

          <span v-if="this.info">
            <admin-info :info="this.info"  v-if="this.info.length > 0"></admin-info>
          </span>

          <v-card
            v-else
            class="mr-3 mt-4 mb-3"
          >
            <v-card-text>
              <span class="subheading">Informationen</span><br><br>
              
              Hier finden Sie alle Termine Ihrer Innung und Kreishandwerkerschaft. <br><br>

              Bitte lassen Sie sich mit Ihrem Betrieb verknüpfen.
              
              
              </v-card-text>

          </v-card>



        </v-flex>
        <v-flex
          xs12
          order-xs3
          order-md2
          md9
          class=""
        >
          <v-sheet
            height="500"
            v-if="this.kalender"
          >
            <v-calendar
              :now="today"
              :value="today"
              ref="calendar"
              v-model="start"
              :type="type"
              color="primary"
              locale="de-DE"
              :weekdays="weekdays"
            >
              <template v-slot:day="{ date }">
                <template v-for="(event, i) in selectedeventsMap[date]">
                  <v-menu
                    :key="event.title + i"
                    v-model="event.open"
                    full-width
                    offset-x
                  >
                    <!-- :class="[event.dunklertext ? 'my-event-dark' : 'my-event-light', event.color]" -->
                    <template v-slot:activator="{ on }">
                      <div
                        v-if="!event.time"
                        v-ripple
                        class="my-event"
                        :class="[{'my-event-dark': event.dunklertext}, event.color ? event.color : 'accent']"
                        v-on="on"
                        v-html="event.title"
                      ></div>
                    </template>
                    <v-card
                      color="grey lighten-4"
                      min-width="350px"
                      flat
                      max-width="30vw"
                    >
                      <v-toolbar
                        :class="event.color"
                        :dark="!event.dunklertext"
                        dense
                      >
                        <!-- <v-btn icon>
                      <v-icon>edit</v-icon>
                    </v-btn> -->
                        <v-toolbar-title v-html="event.title"></v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-btn
                          v-if="darfadmin"
                          icon
                          :dark="!event.dunklertext"
                          @click="dialog = !dialog; deleteevent = event"
                        >
                          <v-icon>delete_forever</v-icon>
                        </v-btn>

                        <!-- 
                        <v-btn icon>
                          <v-icon>favorite</v-icon>
                        </v-btn> -->
                        <!-- <v-btn icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn> -->
                      </v-toolbar>
                      <v-card-text
                        v-if="event.ort"
                        class="pt-3 pb-2"
                      >
                        <v-icon left>location_on</v-icon> <span v-html="event.ort"></span>
                      </v-card-text>
                      <v-card-text
                        v-if="event.kontakt"
                        class="py-2"
                      >
                        <v-icon left>contact_phone</v-icon> <span v-html="event.kontakt"></span>
                      </v-card-text>
                      <v-card-text
                        v-if="event.url"
                        class="py-2"
                      >
                        
                        <v-card flat color="transparent" ma-0 px-0 :href="event.url" target="_blank">
                          <v-icon left>link</v-icon> 
                          <span v-html="event.url"></span>
                        </v-card>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-title v-if="event.details">
                        {{ event.details }}
                      </v-card-title>
                      <v-divider v-if="event.versteckt"></v-divider>
                      <v-card-title
                        v-if="event.versteckt"
                        class="py-2"
                      >
                        <v-icon left>visibility_off</v-icon> Termin nur für angemeldete Nutzer sichtbar.

                      </v-card-title>

                      <!-- {{ event }} -->

                      <!-- 
                        <v-card-actions>
                        <v-btn
                          flat
                          color="secondary"
                        >
                          Schlie&szlig;en
                        </v-btn>
                      </v-card-actions> 
                      -->
                    </v-card>
                  </v-menu>
                </template>
              </template>
            </v-calendar>
          </v-sheet>

          <!-- {{ this.adminkalender }} -->

          <!-- <betriebe-liste
            v-if="this.adminkalender.length > 0"
            :kalender="this.adminkalender"
          ></betriebe-liste> -->

        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card v-if="deleteevent">
        <v-card-title>
          Termin löschen?
        </v-card-title>
        <v-card-text>
          Möchten Sie den Termin <strong>{{ deleteevent.title }}</strong> wirklich löschen?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            @click="dialog=false"
          >Zurück</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="accent"
            @click="terminloeschen(deleteevent); dialog=false"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import TerminListe from '~/components/kalender/TerminListe.vue'
import TerminHinzufugen from '~/components/kalender/TerminHinzufugen.vue'
import BetriebeListe from '~/components/kalender/BetriebeListe.vue'

import AdminInfo from '~/components/kalender/AdminInfo.vue'

import axios from 'axios'

export default {
  components: {
    TerminListe,
    TerminHinzufugen,
    BetriebeListe,
    AdminInfo
    // BildUpload,
    // BildListe,
  },
  data: () => ({
    today: new Date().toISOString().slice(0, 10),
    //  Date().toISOString().slice(0, 10)
    type: 'month',
    weekdays: [1, 2, 3, 4, 5, 6, 0],
    now: null,
    eventhack: true,

    isLoadingKal: false,
    // start: '2019-01-01',
    start: new Date().toISOString().slice(0, 10),
    end: '2019-01-06',
    kalender: [],
    info: [],
    adminkalender: [],
    dialog: false,
    deleteevent: [],
    typeOptions: [
      { text: 'Tag', value: 'day' },
      { text: '4 Tage', value: '4day' },
      { text: 'Woche', value: 'week' },
      { text: 'Monat', value: 'month' }
    ],
    selectedKalender: [],
    darfadmin: false
  }),

  // name: 'home-view',
  metaInfo () {
    return { title: 'Kalender' }
  },
  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap () {
      if (this.kalender) {
        const map = {}
        // this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        if (this.kalender.length > 0) {
          for (const einzelkal of this.kalender) {
            einzelkal.events.forEach(e =>
              (map[e.date] = map[e.date] || []).push(e)
            )
          }
        }
        // console.log(map)
        return map
      }
    },
    limitMap () {
      if (this.kalender) {
        const eventCart = []
        if (this.selectedKalender.length > 0) {
          const heute = new Date()
          for (const einzelkal of this.selectedKalender) {
            if (einzelkal.events) {
              einzelkal.events.forEach(e => {
                if (new Date(e.date) >= heute) {
                  eventCart.push(e)
                }
              })
            }
          }
        }
        return eventCart
      }
    },
    sortedlimitMap () {
      if (this.limitMap) {
        this.limitMap.sort((a, b) => {
          const datum = new Date(a.date) - new Date(b.date)
          return datum
        })
        return this.limitMap.slice(0, 7)
      }
    },
    selectedeventsMap () {
      if (this.selectedKalender) {
        const map = {}
        // this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        if (this.selectedKalender.length > 0) {
          for (const einzelkal of this.selectedKalender) {
            if (einzelkal.events) {
              einzelkal.events.forEach(e =>
                (map[e.date] = map[e.date] || []).push(e)
              )
            }
          }
        }
        // console.log(map)
        return map
      }
    },
    deutscherMonat () {
      const d = new Date(this.start)
      return ' ' + d.toLocaleString('de-DE', { month: 'long', year: 'numeric' })
    },
    likesAllFruit () {
      if (this.selectedKalender) {
        return this.selectedKalender.length === this.kalender.length
      }
    },
    likesSomeFruit () {
      return this.selectedKalender.length > 0 && !this.likesAllFruit
    },
    icon () {
      if (this.likesAllFruit) return 'check_box'
      if (this.likesSomeFruit) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    }
  },
  mounted: function () {
    this.getKalender()
  },
  methods: {
    open (event) {
      alert(event.title)
    },
    getKalender: function () {
      this.isLoadingKal = true
      const self = this
      axios
        .get('/api/v1/kalender')
        .then(resp => {
          // console.log(resp)
          self.kalender = resp.data.kalender
          self.darfadmin = resp.data.darfadmin
          self.info = resp.data.kalenderadmininfo
          if (resp.data.adminkalender) {
            self.adminkalender = resp.data.adminkalender
          }
          // console.log(self.kalender)
        })
        .catch(err => {
          console.log(err)
          self.$store.dispatch('responseMessage', {
            type: 'warning',
            text: 'Leider keine Kalender für Sie verfügbar.'
          })
        })
        .finally(() => {
          this.isLoadingKal = false
          this.activateKalenders()
        })
    },
    activateKalenders: function () {
      if (this.kalender) {
        this.selectedKalender = this.kalender
      }
    },
    toggle () {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedKalender = []
        } else {
          this.selectedKalender = this.kalender.slice()
        }
      })
    },
    terminloeschen: function (item) {
      const app = this
      const itemid = item.id
      axios
        .delete('/api/v1/kalender/' + itemid)
        .then(function (resp) {
          // console.log(hashid)
          console.log('gelöscht: ' + itemid)
          app.$store.dispatch('responseMessage', {
            type: 'success',
            text: 'Termin gelöscht!'
          })
          app.getKalender()
        })
        .catch(function (error) {
          console.log(error)
          app.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Leider keine Berechtigung, konnte Termin nicht löschen.'
          })
        })
    },
    created () {}
  }
}
</script>


<style lang="stylus" scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  color: #fff;
  cursor: pointer;
  margin-bottom: 1px;
}

.my-event-dark {
  color: #000 !important;
}

.my-event-light {
  color: #ffffff;
}

.feature-pane {
  position: relative;
  padding-top: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
</style>

